/**
 * @file: cabinet tpl申明
 * @author: xiaolong.huang@dmall.com
 */

let tpl: string[] = [
    '<div class="shelvesbuild-e-p-cabinet is-partition" data-stagecore>',
        '<div class="shelvesbuild-e-p-cabinet-slot J_ElementPartitionCabinetSlot slot"></div>',
        '<div class="partition-cabinet-bone J_PartitionCabinetBone">',
            '<div class="cabinet-tags">',
                '<div class="tags-text J_cabinetTags"></div>',
            '</div>',
        '</div>',
    '</div>'
];

export default tpl.join('');
